import { styled } from "@mui/material";

import { Box, CircularProgress } from "@tsp/tsp-frontend-components/mui";

export const AsyncDataSuspenseBox = styled(Box)`
  width: 100%;
  height: 100%;
`;

export const AsyncDataSuspenseInner = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const AsyncDataSuspenseOverlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  text-align: center;
`;

export const AsyncDataSuspenseCircularProgress = styled(CircularProgress)``;

export const AsyncDataSuspenseExceptions = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 100%;
  min-height: 100%;
`;

export const AsyncDataSuspenseException = styled(Box)``;

export const AsyncDataSuspenseLink = styled(Box)`
  padding: ${({ theme }) => theme.spacing(1, 0, 0)};
`;
